/**
 * 
 * Supplemental file for Favorites customizations in order to assist in upgrade paths.
 *
 */
define('modules/Favorites/FavoritesCustomizations',[
'lodash',
'jquery',
'global/all',
'./FavoritesManager',
'modules/Cart/CartManagerCustomizations',
'modules/Cart/CartLocker',
'plugins/magnific-popup'
], function (_, $, Roc, FavoritesManager, CartManagerCustom, CartLocker) {
    'use strict';

    var listId = null;

    var apiUrl = window.RocConfig.api.baseRocApiUrl;
    
    var listActionsType = {
        MAKE_PUBLIC: 1,
        MAKE_PRIVATE: 2
    };
    
    var selectors = {
        sendBtn: '[data-roc-action="sendFavoritesList"]',
        addToCartItemCheckbox: 'input[type="checkbox"][data-roc-action="selectFavItemAddToCart"]',
        addSelectedItemsToFavorites: 'button[data-roc-action="addSelectedItemsToFavorites"]',
        selectAllItemsToAddToCart: '[data-roc-action="selectAllItemsToAddtoCart"]',
        selectListAction: 'select[data-roc-action="listAction"]',
        deleteListBtn: 'button[data-roc-action="deleteList"]'
    }

    var emailListForm = {
        Fields: [
            {
                "Name": 'Email Address',
                "Field": '#emailFavorites input#emailAddress',
                "Param": 'sendToEmail',
                "Type": 'Text',
                "Validators": [
                    {
                        "Type": 'Email'
                    }
                ]
            }
        ],
        Validate: true
    };

    function sendEmail(requestData) {
        return $.ajax({
            type: 'POST',
            url: apiUrl + '/api/favorites/customizations/email',
            data: JSON.stringify(requestData),
            contentType: 'application/json; charset=utf-8',
            dataType: 'json'
        });
    }

    function updateListPrivacy(isPublic) {
        return $.ajax({
            type: 'POST',
            url: apiUrl + '/api/favorites/customizations/list/' + listId + '/privacy/' + (isPublic === true ? "1" : "0"),
            contentType: 'application/json; charset=utf-8'
        });
    }

    function listActionEvt() {
        $(document).on('change', selectors.selectListAction, function () {
            var selectedAction = parseInt($('option:selected', this).val());
            if (!isNaN(selectedAction)) {
                var deferred = null;
                switch (selectedAction) {
                    case listActionsType.MAKE_PUBLIC:
                        deferred = updateListPrivacy(true);
                        break;
                    case listActionsType.MAKE_PRIVATE:
                        deferred = updateListPrivacy(false);
                        break;
                }

                if (deferred !== undefined && deferred !== null) {
                    Roc.UI.block();
                    deferred.then(
                        function () {
                            Roc.UI.success('List privacy has been changed', 'Favorites Privacy');
                        },
                        function (response) {
                            Roc.UI.ajaxErrorPopup(response);
                        }).always(function () {
                            Roc.UI.unblock();
                    });
                }
            }
        });
    }

    function deleteListEvt() {
        Roc.UI.siteBody
            .off('click', selectors.deleteListBtn)
            .on('click', selectors.deleteListBtn, function (e) {
                if (confirm('Are you sure you want to delete this favorites list?')) {
                    FavoritesManager.deleteList(listId);
                }
            });
    }

     /**
     * make() returns a new element
     * based on the passed in tag name
     *
     * @param {Object} trigger - optional jquery object of trigger selector
     */
    function openEmailList(listId) {
        Roc.UI.template('favoritesEmailList-Tmp')
            .then(function (renderedTemplate) {
                Roc.UI.Modal.open(renderedTemplate, {
                        open: function () {
                            Roc.UI.siteBody.on('click', selectors.sendBtn, function () {
                                if (!Roc.Validation.validateForm(emailListForm)) {
                                    return;
                                }

                                var data = Roc.Forms.getFormValues(emailListForm);
                                _.assign(data, {
                                        'listId': listId
                                    });

                                Roc.Core.lockButton(selectors.sendBtn);
                                sendEmail(data).then(
                                    function () {
                                        Roc.UI.Modal.alert('Your list has been sent to ' + data.sendToEmail, 'List sent');
                                    },
                                    function (response) {
                                        Roc.UI.ajaxErrorPopup(response);
                                }).always(function () {
                                    Roc.Core.releaseLockedButton(selectors.sendBtn);
                                });
                            });
                        },
                        close: function () {
                            Roc.UI.siteBody.off('click', selectors.sendBtn);
                        }
                    });
            });
    }

    function updateAddToCartButtonLabel() {
        var itemsSelected = $(selectors.addToCartItemCheckbox).filter(':checked').length;
        var btnLabel;
        var isDisabled = false;
        switch (itemsSelected) {
        case 0:
            btnLabel = 'Add Selected Items To Cart';
            isDisabled = true;
            break;
        case 1:
            btnLabel = 'Add Selected Item (1) To Cart';
            break;
        default:
            btnLabel = 'Add Selected Items (' + itemsSelected + ') To Cart';
            break;
        }

        var $btns = $(selectors.addSelectedItemsToFavorites);
        $btns.text(btnLabel);
        $btns.attr('disabled', isDisabled);
    }

    function addToCartItemCheckboxEvt() {
        Roc.UI.siteBody
            .off('change', selectors.addToCartItemCheckbox)
            .on('change', selectors.addToCartItemCheckbox,function(e) {
                updateAddToCartButtonLabel();
            });

    }

    function addSelectedItemsToFavoritesEvt() {
        Roc.UI.siteBody
            .off('click', selectors.addSelectedItemsToFavorites)
            .on('click', selectors.addSelectedItemsToFavorites, function (e) {
                var $itemsToAdd = $(selectors.addToCartItemCheckbox).filter(':checked');
                if ($itemsToAdd.length === 0) {
                    return;
                }

                var request = {
                    tempAddressId: CartManagerCustom.getTempAddressId(),
                    itemsToAdd: []
                };
                $itemsToAdd.each(function (i) {
                    var $wrapper = $(this).closest('.itemWrapper');
                    var rocParams = $wrapper.getRocParamsObject();
                    var wantsQty = parseInt($wrapper.find('.itemAction input.addQty').val());
                    request.itemsToAdd.push({
                        productId: rocParams.id,
                        name: rocParams.name,
                        quantity: isNaN(wantsQty) ? 1 : Math.max(1, wantsQty)
                    });
                });

                var message = 'Do you want to add below item';
                message += request.itemsToAdd.length === 1 ? ' ' : 's ';
                message += 'to your cart?<br /><ul>';
                for (var i in request.itemsToAdd) {
                    if (!request.itemsToAdd.hasOwnProperty(i)) {
                        continue;
                    }
                    message += '<li>' + request.itemsToAdd[i].name + ', Qty: ' + request.itemsToAdd[i].quantity + '</li>';
                }
                message += '</ul>';

                Roc.UI.confirm({
                    "title": 'Add To Cart',
                    "message": message,
                    "buttons": {
                        "Continue": {
                            "class": 'btn btnAction btnConfirmAddToCartFavItems',
                            "autoClose": false,
                            "action": function () {
                                $('.btnCloseConfirmAddToCartFavItems').trigger('click');
                                CartLocker.isCartLocked()
                                    .then(function() {
                                        Roc.Core.lockButton(selectors.addSelectedItemsToFavorites);
                                        CartManagerCustom.bulkAddToCart(request)
                                            .always(function() {
                                                Roc.Core.releaseLockedButton(selectors.addSelectedItemsToFavorites);
                                            });
                                    });
                            }
                        },
                        "Cancel": {
                            "class": 'btn btnCloseConfirmAddToCartFavItems',
                            "action": function() {}
                        }
                    }
                });
            });
    }

    function selectAllItemsToBeAddedToCartEvt() {
        Roc.UI.siteBody
            .off('click', selectors.selectAllItemsToAddToCart)
            .on('click', selectors.selectAllItemsToAddToCart, function (e) {
                $(selectors.addToCartItemCheckbox + ':not(:disabled)').prop('checked', true);
                updateAddToCartButtonLabel();
            });
    }

    function clearSelection() {
        $(selectors.addToCartItemCheckbox).prop('checked', false);
        updateAddToCartButtonLabel();
    }

    function bindEvents() {
        listActionEvt();
        addToCartItemCheckboxEvt();
        addSelectedItemsToFavoritesEvt();
        selectAllItemsToBeAddedToCartEvt();
        deleteListEvt();
    }

    function setListId(id) {
        listId = id;
    }

    function init() {
        bindEvents();
    }

    var FavoritesCustomizations = {
        openEmailList: openEmailList,
        clearSelection: clearSelection,
        init: init,
        setListId: setListId
    };
    
    Roc.Logger.debug('FavoritesCustomizations.js Loaded:', FavoritesCustomizations);

    return FavoritesCustomizations;
});
